import { ItemGroup } from '@sleepstation/components'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { parseHtmlToAst } from '@sleepstation/markdown'
import PropTypes from 'prop-types'
import React from 'react'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Consideration = ({ title, description }) => (
  <ItemGroup dataCy={`consideration`} title={title} isClose>
    <CopyRenderer htmlAst={parseHtmlToAst(description)} />
  </ItemGroup>
)

Consideration.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default Consideration
